import React from 'react';
import { Link } from 'react-router-dom';

import { markMastersLinkClicked } from '../../../services/api';
import { windowShape } from '../../../services/astraLite';
import { MASTERS_LINK } from '../../../config/regions';
import { MASTERS_LINK_COPY as COPY } from '../../../content/mastersWaitlist';

// The home page's one line to /masters (#4985; the same in every mock
// variant): for the regions whose strategy shows it (the default region, the
// US included; India has the full Master's section instead). Placed low, after
// the counselor line, so the undergrad families the page is for are not
// displaced. The click is counted server-side (masters-link-click ->
// masters_link_clicked); the page's own instrumentation adds the CTA click.

/** True when the line belongs on this page view. Pure, for tests. */
export function mastersLinkVisible({ flagOn, region }) {
    return Boolean(flagOn) && Boolean(region?.showsSection?.(MASTERS_LINK));
}

/** Where the line goes: /masters, with a ?region= override carried along so
 *  QA sees the same region on both pages (design spec section 3). Pure. */
export function mastersHref(region, regionSource) {
    return regionSource === 'override' ? `${COPY.to}?region=${region.code}` : COPY.to;
}

export default function MastersLink({ region, regionSource }) {
    const clicked = () => {
        markMastersLinkClicked({ region: region.code, region_source: regionSource, ...windowShape() });
    };
    return (
        <div data-landing-section="masters_link" className="bg-[#FDFCF7] px-4 pb-10 sm:px-6 lg:px-8">
            <p data-testid="landing-masters-link" className="mx-auto max-w-3xl text-center text-base text-[#4A4A4A]">
                {COPY.lead}{' '}
                <Link to={mastersHref(region, regionSource)} data-cta="masters_link" onClick={clicked}
                    className="inline-flex min-h-[44px] items-center font-semibold text-[#1A4D2E] underline decoration-[#CFE3D4] underline-offset-4">
                    {COPY.link}
                </Link>
            </p>
        </div>
    );
}
